import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamAPIResponse } from "yinzcam-api";
import { YinzCamAppServerToken } from "yinzcam-appserver";

@injectable()
export class YinzCamAppServerTeamTeamsListFilterOptions extends CardsDataSourceBase {
  public constructor(@injectToken(YinzCamAppServerToken) server) {
    super({ server })
  }

  protected processResponse(response: YinzCamAPIResponse): object | any[] {
    let data = response?.data as any;
    let firstSection = [].concat(data?.TeamsList.Section).find((e, i) => i === 0);
    let options = [].concat(firstSection?.Team).filter(team => team?._attributes?.Id).map(team => {
      let attrs = team?._attributes;
      return {
        title: attrs?.FullName,
        value: attrs?.Id
      };
    });
    return { options };
  }
}
